import _ from 'lodash'
import Util from '@/lib/util'

export default {
  methods: {
    raiseFormErrorMessage(response) {
      if (!this.isResponseWithFormError(response)) {
        return false
      }

      this.$alertify.error(this.getFormErrorMessage(response))

      return true
    },
    isResponseWithFormError(response) {
      return !!this.getFormErrorMessage(response)
    },
    getFormErrorMessage(response) {
      const messages = this.getFormErrorMessages(response)
      if (!messages) {
        return null
      }

      return Util.getFirstLiteralValue(messages)
    },
    getFormErrorMessages(response) {
      let formErrors = null

      formErrors = _.get(response, 'response.data.formErrors')
      if (formErrors && (_.isArray(formErrors) || _.isObject(formErrors))) {
        return formErrors
      }

      formErrors = _.get(response, 'data.formErrors')
      if (formErrors && (_.isArray(formErrors) || _.isObject(formErrors))) {
        return formErrors
      }

      return []
    }
  }
}
